import { Space } from 'antd';
import { FormattedMessage } from 'react-intl';

import { api } from '@/api';
import { DeleteAction, EditAction } from '@/components/table/actions';
import { getColumnSearchFields } from '@/components/table/filters';
import { PERMISSION_DELETE, PERMISSION_OBJ_CONSORTIUM, PERMISSION_UPDATE } from '@/constants/permissions';
import { withPermissions } from '@/hocs/permission';
import { consortiumStore } from '@/stores';
import { showError } from '@/utils/common';

const PermissionedEditAction = withPermissions([[PERMISSION_OBJ_CONSORTIUM, PERMISSION_UPDATE]])(EditAction);
const PermissionedDeleteAction = withPermissions([[PERMISSION_OBJ_CONSORTIUM, PERMISSION_DELETE]])(DeleteAction);

const Actions = (_: any, record: cyrian.api.consortiums.Consortium) => {
  const onDelete = () => {
    api.consortiums
      .delete(record.id)
      .source.then(() => consortiumStore.deleteItem(record.id))
      .catch(showError);
  };

  return (
    <Space onClick={(e) => e.stopPropagation()}>
      <PermissionedEditAction uiSref={{ to: 'base-layout.consortiums.edit', params: { consortiumId: record.id } }} />
      <PermissionedDeleteAction onConfirm={onDelete} />
    </Space>
  );
};

export const columns = [
  {
    title: 'id',
    dataIndex: 'id',
    width: 60,
    sorter: true,
  },
  {
    title: <FormattedMessage id="counterparties.name" />,
    dataIndex: 'name',
    ...getColumnSearchFields(),
  },
  {
    title: <FormattedMessage id="consortiums.cooperatives" />,
    dataIndex: 'cooperatives',
    sorter: false,
    render: (_: any, record: cyrian.api.consortiums.Consortium) =>
      record.cooperatives?.map((c) => c.name).join(', ') ?? null,
  },
  {
    title: '',
    render: Actions,
    className: 'actions',
  },
];
